// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._9f6868{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;gap:20px}.dfe781{font-family:-apple-system,BlinkMacSystemFont,\"SF Pro Display\",sans-serif;font-size:50px;font-weight:200;letter-spacing:2px;color:var(--primary);text-align:center;padding:40px;background:rgba(245,245,245,.95);border-radius:50%;width:200px;height:200px;display:flex;align-items:center;justify-content:center;margin:0 auto;box-shadow:inset 0 0 10px var(--primary);font-variant-numeric:tabular-nums;font-feature-settings:\"tnum\"}@media(max-width: 480px){.dfe781{font-size:60px;width:180px;height:180px;padding:30px}}", ""]);
// Exports
exports.locals = {
	"stopwatch": "_9f6868",
	"timeCircle": "dfe781"
};
module.exports = exports;
